import { useState } from "react";
import { useSite } from "../../lib/useSite";
import { api, apiError } from "../../lib/api";
import { Eyebrow } from "../../components/bits";
import { toast } from "sonner";
import { Mail, Clock, MapPin } from "lucide-react";

const field = "w-full bg-white border border-[#e0ddd4] rounded-sm px-4 py-3 text-sm focus:border-[#d4af37]";
const labelCls = "text-xs tracking-wide text-[#555] uppercase mb-1.5 block";

export default function Contact() {
  const site = useSite();
  const b = site?.business || {};
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const [done, setDone] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!f.name || !/.+@.+\..+/.test(f.email) || !f.message) { toast.error("Please complete all required fields"); return; }
    try { await api.post("/public/contact", f); setDone(true); toast.success("Message sent"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <section className="bg-[#0a0a0a] relative">
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-14">
          <Eyebrow dark>Contact</Eyebrow>
          <h1 className="font-display text-[#fdfbf7] text-5xl sm:text-6xl tracking-tight">Get in touch</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <p className="text-[#555] leading-relaxed">Our reception assistant Rachel is available on the website 09:00–17:00. For anything else, send us a message and we'll respond as soon as possible.</p>
          <div className="mt-8 space-y-5">
            <div className="flex items-center gap-3"><Mail className="text-[#d4af37]" size={20} /><span className="text-sm">{b.email || "blackdiamondelitecleaning@gmail.com"}</span></div>
            <div className="flex items-center gap-3"><Clock className="text-[#d4af37]" size={20} /><span className="text-sm">{b.hours || "Mon–Sat 09:00–17:00"}</span></div>
            <div className="flex items-center gap-3"><MapPin className="text-[#d4af37]" size={20} /><span className="text-sm">{b.primary_area || "North London, NW London & Watford"}</span></div>
          </div>
        </div>
        <div className="card-luxe p-8">
          {done ? (
            <p className="text-[#555]">Thank you — your message has been received and logged. We'll be in touch shortly.</p>
          ) : (
            <div className="grid grid-cols-1 gap-5">
              <div><label className={labelCls}>Name *</label><input data-testid="contact-name" className={field} value={f.name} onChange={(e) => set("name", e.target.value)} /></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className={labelCls}>Email *</label><input data-testid="contact-email" className={field} value={f.email} onChange={(e) => set("email", e.target.value)} /></div>
                <div><label className={labelCls}>Phone</label><input className={field} value={f.phone} onChange={(e) => set("phone", e.target.value)} /></div>
              </div>
              <div><label className={labelCls}>Message *</label><textarea rows="5" data-testid="contact-message" className={field} value={f.message} onChange={(e) => set("message", e.target.value)} /></div>
              <button data-testid="contact-submit" onClick={submit} className="btn-gold px-8 py-3 rounded-sm">Send message</button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
